import React, { useEffect, useState } from 'react';
import { ButtonStyled } from '../../../common/Button/styled';
import { useNavigate } from 'react-router-dom';

export const JiraIssueButton = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const accessToken = localStorage.getItem('access_token');
    setIsLoggedIn(!!accessToken);
  }, []);

  const handleClick = () => {
    if (isLoggedIn) {
      navigate('/jira-issue');
    } else {
      navigate('/auth/jira');
    }
  };

  return (
    <ButtonStyled onClick={handleClick}>
      {isLoggedIn ? 'Przejdź do zgłoszeń portalu wsparcia' : 'Zaloguj się'}
    </ButtonStyled>
  );
};
